import { render, staticRenderFns } from "./EdcDetail.vue?vue&type=template&id=0efc5dd0"
import script from "./EdcDetail.vue?vue&type=script&lang=js"
export * from "./EdcDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports